import { BetStatusId } from '@/models/bet/status/id';
import { Decimal } from '@starsoft/common/services/Decimal';
import { useCountUp } from 'use-count-up';
import { GameReportBoardBet } from '../props';
import { Container, Counter, SatelliteImage } from './styles';

export default function LimboGameBoardReport({
  bet,
}: GameReportBoardBet): JSX.Element {
  const { value: multiplier } = useCountUp({
    start: 1,
    end: Decimal.fromSubunits(bet?.multiplier, {
      scale: 4,
    }).toNumber(),
    isCounting: true,
    decimalPlaces: 2,
    duration: 0.7,
    formatter: value => `${value.toFixed(2)}x`,
  });

  return (
    <Container isSecondaryStyles>
      <Counter
        won={bet?.status?.statusId?.toString() == BetStatusId.Won?.toString()}
      >
        {multiplier}
      </Counter>
      <SatelliteImage
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/limbo/satelite.svg`}
      />
    </Container>
  );
}
